import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import { request } from "../../../utils/request";
import Modal from "../../general/Modal";
import Edit from "./Edit";
import Create from "./Create";

const Ubicaciones = () => {
    const [ubicaciones, setUbicaciones] = useState({});
    const [ubicacion, setUbicacion] = useState({});
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    const getUbicaciones = async (url = null) => {
        setLoading(true);

        const ubicaciones = await request(url ?? "ubicaciones");

        if (ubicaciones.data) {
            setUbicaciones(ubicaciones.data);
        }

        setLoading(false);
    };

    const toggleCreateModal = () => {
        setUbicacion({});

        setShowCreate(!showCreate);
    };

    const toggleEditModal = (ubicacion) => {
        setUbicacion(ubicacion);

        setShowEdit(!showEdit);
    };

    useEffect(() => {
        getUbicaciones();
    }, []);

    return <div>
        <div className='page-header'>
            <Link to={getLink('/productos/')}>&laquo; Volver a productos</Link>
            <h1 className='page-title row'>
                <span className='col'>Ubicaciones de Inventario</span>
                <button
                    className='au-btn au-btn-icon au-btn--green au-btn--small'
                    onClick={toggleCreateModal}>
                    <i className='zmdi zmdi-plus' />
                    Añadir Ubicación
                </button>
            </h1>
        </div>

        <div className='row'>
            <div className='col-md-12'>
                <div>
                    {loading && <Loader />}
                    {!ubicaciones.length ? (
                        <div>
                            {!loading && (
                                <div>
                                    Todavía no hay Ubicaciones creadas.
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className='table-data'>
                            <table className='table table-data2'>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Productos</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {ubicaciones.map((ubicacion) => (
                                        <tr
                                            className='tr-shadow'
                                            key={ubicacion.id}>
                                            <td>{ubicacion.nombre}</td>
                                            <td>{ubicacion.productos}</td>
                                            <td>
                                                <div className='table-data-feature'>
                                                    <button
                                                        className='item'
                                                        data-toggle='tooltip'
                                                        data-placement='top'
                                                        title=''
                                                        data-original-title='Edit'
                                                        onClick={() => {
                                                            toggleEditModal(ubicacion);
                                                        }}>
                                                        <i className='zmdi zmdi-edit' />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>

        <Modal
            show={showCreate}
            blank={true}
            toggle={toggleCreateModal}>
            <Create
                toggle={toggleCreateModal}
                getUbicaciones={getUbicaciones}
            />
        </Modal>
        <Modal
            show={showEdit}
            blank={true}
            toggle={() => toggleEditModal({})}>
            <Edit
                toggle={() => toggleEditModal({})}
                ubicacion={ubicacion}
                getUbicaciones={getUbicaciones}
            />
        </Modal>
    </div>;
};

export default Ubicaciones;